<template>
  <div>
    <TransactionsTable />
    <Base--SideButtons />
  </div>
</template>

<script>
import TransactionsTable from '@/components/common/Table/TransactionTable/TransactionsTable.vue'

export default {
  name: 'Transactions',
  components: { TransactionsTable }
}
</script>

<style scoped></style>
